import { render, staticRenderFns } from "./like.vue?vue&type=template&id=55881018&scoped=true"
import script from "./like.vue?vue&type=script&lang=js"
export * from "./like.vue?vue&type=script&lang=js"
import style0 from "./like.vue?vue&type=style&index=0&id=55881018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55881018",
  null
  
)

export default component.exports